import { render, staticRenderFns } from "./NewCourseStep2Question.vue?vue&type=template&id=1f2f83ef"
import script from "./NewCourseStep2Question.vue?vue&type=script&lang=js"
export * from "./NewCourseStep2Question.vue?vue&type=script&lang=js"
import style0 from "./NewCourseStep2Question.vue?vue&type=style&index=0&id=1f2f83ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports